import isWebComponentGame from '@/shared/utils/isWebComponentGame';

export default function canShowFunMode(game?: SingleGameFragment): boolean {
  if (isWebComponentGame(game?.handle)) {
    return false;
  }

  return game?.hasFunMode ?? false;
}
